@for (toast of toastService.toasts(); track toast; let i = $index) {
  <div
    class="toast d-flex flex-column align-content-center"
    [ngClass]="toast.type == 'error' ? 'error' : ''"
    style="position: fixed"
    >
    <div class="d-flex flex-row align-items-center psic-gap-3 w-100" [ngClass]="toast.type == 'error' ? 'align-items-start' : 'align-items-center'" >
      <div class="d-flex flex-row align-items-center psic-gap-2">
        @if (toast.type == 'error') {
          <mat-icon [svgIcon]="'exclamation-octagon'" class="mat-icon-32 s2-10-color"></mat-icon>
        }
        @if (toast.type != 'error') {
          <mat-icon [svgIcon]="'check-circle'" class="mat-icon-32 s1-70-color"></mat-icon>
        }
        <div class="d-inline-flex text-break caption wh-100-color psic-pl-2">{{ toast.message }}</div>
      </div>
      <mat-icon [svgIcon]="'close'" (click)="remove(i)" class="mat-icon-24 s2-10-color" style="cursor: pointer;"></mat-icon>
    </div>
  </div>
}
